/* istanbul ignore file */
(function () {
    // meet the true enemy ... browser support :D
    let passiveEvent = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            get() {
                passiveEvent = true;
            }
        });
        window.addEventListener("test", () => { }, opts);
    }
    catch (e) { }
    passiveEvent = passiveEvent ? { capture: true, passive: true } : true;
}());
function sbFindIframeContentWindow(s) {
    let iframe;
    let f = document.getElementsByTagName("iframe");
    iframe = Array.prototype.filter.call(f, x => x.src.match(s))[0];
    linkedFrames.push(iframe);
    let contentWindow = iframe && iframe.contentWindow;
    return contentWindow;
}
function sbRemoveFromList(list, item) {
    let i = list.indexOf(item);
    i > -1 && list.splice(i, 1);
}
function cacheMaintainer(t, m) { messagesCache[t] = m; }
function garbageColletor() {
    if (window["sbMsgBus"]) {
        let b = window["sbMsgBus"];
        Object.keys(b.topics).forEach(x => {
            if (b.topics[x].length === 0) {
                delete b.topics[x];
                delete messagesCache[x];
            }
        });
    }
}
function initGC() {
    garbageColletor();
    setTimeout(initGC, 10000);
}
setTimeout(initGC, 10000);
const messagesCache = {};
// nulled on deactivate - needs to be VAR
var linkedFrames = [];
var linkedWindows = [];
const internalPrefix = "sb-mbus-";
const sbPrefix = "sb_";
// !!! IMPORTANT
// -> window.opener is not consistent between web browsers!
/**
 * SBMsgBus
 * Establishes a way for our application to communicate between iframes and windows created by window.open(...)
 */
export class SBMsgBusClass {
    constructor() {
        this.sbPrefix = sbPrefix;
        this.type = "parent";
        this.isActive = false;
        // tslint:disable-next-line
        this.topics = Object.create(null);
        this.receiveMessages = this.receiveMessages.bind(this);
        this.deactivate = this.deactivate.bind(this);
        this.activate();
    }
    activate() {
        this.isActive = true;
        this.type = "parent";
        if ((window.opener !== null && window.opener !== undefined) || window.parent !== window) {
            this.initAsChild();
        }
        window.addEventListener("onunload", this.deactivate, true);
        window.addEventListener("message", this.receiveMessages, true);
        this.link(window);
        return this;
    }
    deactivate() {
        this.isActive = false;
        // tslint:disable-next-line
        this.topics = Object.create(null);
        this.post({ "sb-mbus-unlink": window.location.toString() });
        linkedFrames = [];
        linkedWindows = [];
        window.removeEventListener("onunload", this.deactivate, true);
        window.removeEventListener("message", this.receiveMessages, true);
        this.unlink(window); // unlink self for messages
        return this;
    }
    initAsChild() {
        this.type = "child";
        this.link((window.opener === null || window.opener === undefined) ? window.parent : window.opener);
        this.post({ "sb-mbus-link": window.location.origin.toString() });
        return this;
    }
    /* tslint:disable:cyclomatic-complexity */
    link(s) {
        if (!this.isActive) {
            return this;
        }
        let sibling;
        if (typeof s === "string") {
            sibling = sbFindIframeContentWindow(s);
        }
        //For some reason in IE postMessage is object
        if (typeof s === "object" && (typeof s["postMessage"] === "function" || typeof s["postMessage"] === "object")) {
            sibling = s;
        }
        if (sibling) {
            linkedWindows.indexOf(sibling) === -1 && linkedWindows.push(sibling);
        }
        return this;
    }
    unlink(s) {
        if (!this.isActive) {
            return this;
        }
        let sibling;
        if (typeof s === "string") {
            sibling = sbFindIframeContentWindow(s);
        }
        //For some reason in IE postMessage is object
        if (typeof s === "object" && (typeof s["postMessage"] === "function" || typeof s["postMessage"] === "object")) {
            sibling = s;
        }
        if (sibling) {
            sbRemoveFromList(linkedWindows, sibling);
        }
        return this;
    }
    /* tslint:enable:cyclomatic-complexity */
    receiveMessages(e) {
        let m;
        try {
            m = JSON.parse(e.data);
        }
        catch (err) {
            m = undefined;
        }
        m && this.routeMessages(m);
        return this;
    }
    routeMessages(m) {
        if (m) {
            Object.keys(m).forEach(x => {
                if (x.match(internalPrefix)) {
                    try {
                        this[x.replace(internalPrefix, "")](m[x]);
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
                else if (x.match(sbPrefix)) {
                    if (Array.isArray(this.topics[x])) {
                        this.topics[x].forEach(y => {
                            if (typeof y === "function") {
                                setTimeout(() => {
                                    try {
                                        y(m[x]);
                                    }
                                    catch (err) {
                                        console.error(err);
                                    }
                                });
                            }
                        });
                    }
                    cacheMaintainer(x, m[x]);
                }
            });
        }
        return this;
    }
    subscribe(t, c, useCache = true) {
        if (typeof this.topics[t] === "undefined") {
            this.topics[t] = [];
        }
        this.topics[t].indexOf(c) === -1 && this.topics[t].push(c);
        if (useCache && typeof messagesCache[t] !== "undefined") {
            c(messagesCache[t]);
        }
    }
    unsubscribe(t, c) {
        if (Array.isArray(this.topics[t])) {
            sbRemoveFromList(this.topics[t], c);
        }
    }
    post(m) {
        let s;
        try {
            s = JSON.stringify(m);
        }
        catch (err) {
            s = "";
            console.error(`Tried to send malformed message: ${m}, err > ${err}`);
        }
        linkedWindows.forEach(x => {
            if (typeof x !== "undefined" && (typeof x.postMessage === "function" || typeof x["postMessage"] === "object")) {
                try {
                    x.postMessage(s, "*");
                }
                catch (err) {
                    console.error(err);
                }
            }
        });
        return this;
    }
}
export const sbMsgBusInstance = window["sbMsgBus"] || new SBMsgBusClass();
//# sourceMappingURL=mbus.js.map